<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <Alert :text="$t('pacto_users_module_validation_required_error')" type="danger" dismissable="false"
                v-if="!loaderData && requiredError" />
              <Alert :text="$t('pacto_users_module_validation_email_error')" type="danger" dismissable="false"
                v-if="!loaderData && emailError" />
              <Alert :text="$t('pacto_users_module_validation_email_error')" type="danger" dismissable="false"
                v-if="!loaderData && pactoEmailError" />
              <Alert :text="$t('pacto_users_module_validation_name_error')" type="danger" dismissable="false"
                v-if="!loaderData && nameError" />
              <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismissable="false"
                v-if="!loaderData && pactoComplaintWhatsappValidError" />
              <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismissable="false"
                v-if="!loaderData && pactoComplaintPhoneErrorValid" />
              <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismissable="false"
                v-if="!loaderData && pactoPhoneValidError" />
              <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismissable="false"
                v-if="!loaderData && phoneWhatsappValidError" />
              <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismissable="false"
                v-if="!loaderData && phoneComplaintValidError" />

              <Alert :text="$t('pacto_users_module_validation_icon_error')" type="danger" dismissable="false"
                v-if="iconError" />
              <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiError" />
              <div class="card-header headerDiv" style="padding: 0rem 1.7rem">
              </div>
              <div class="card-content divHeading">
                <div class="col-md-12 firstDiv">
                  <div class="col-md-7">
                    <h6 class="headingStyleOrg" style="margin-left:1em">{{
    $t('pacto_settings_organization_branding_heading')
}}</h6>
                    <div class="form-group row uploadDiv dotedDivStyle">

                      <div class="col-md-5 uploadDivStyle" id="preview">
                        <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                          <span class="sr-only">{{ $t('common_module_loader_label') }}</span>
                        </div>
                        <img v-if="url" :src="url" :alt="$t('error_message_for_loading_image')" width="155"
                          height="100" />
                        <img v-if="icons && !url" :alt="$t('error_message_for_loading_image')" :src="icons" width="155"
                          height="100" />
                        <p class="dimensionStyle">{{ $t('pacto_settings_change_logo_dimension') }}</p>
                      </div>
                      <div class="col-md-6 col-sm-12 uploadDivStyle"
                        :class="url ? 'uploadDivStyle uploadButtonStyle' : 'uploadDivStyle '">
                        <div class="form-group row">
                          <button type="button" class="btn btn-light-secondary ml-1 buttonDeleteLogoStyle"
                            @click="deleteLogo()">
                            <em class="bx bx-check d-block d-sm-none"></em>
                            <span class="d-none d-sm-block deleteLogoFont">{{ $t('pacto_settings_delete_logo_button')
}}</span>
                          </button>
                          <span>

                            <label class="btn  ml-1 buttonChangeStyle" for="my-file"> <em
                                class="bx bx-check d-block d-sm-none"></em><span class="d-none d-sm-block">{{
    $t('pacto_settings_change_logo_button')
}}</span></label>
                            <input type="file" accept="image/*" @change="onFileChange($event)" class="form-control-file"
                              id="my-file" style="display:none">


                          </span>
                        </div>
                        <p class="formatStyle">
                          {{ $t('pacto_settings_change_logo_supported_format') }}</p>
                      </div>

                    </div>


                  </div>
                  <h6 class="headingSecondStyle" style="margin-left:2em">{{
    $t('pacto_settings_organization_name_heading')
}}</h6>

                  <div class="form-group row streetRow">
                    <div class="col-md-6 col-sm-12">
                      <label for="org-name " class="postalCodeBillingLabel ">{{
    $t('pacto_settings_module_default_language')
}}</label>
                      <input type="text" class="form-control streetInput"
                        :class="!loaderData && pactoDefaultLanguageError ? ' form-control errClass' : ' form-control'"
                        :placeholder="$t('pacto_settings_module_org_name_placeholder')" v-model="pactoDefaultLanguage"
                        @keyup="defaultLanguageValidation" />

                    </div>
                    <div class="col-md-6 col-sm-12">
                      <label for="org-name " class="postalCodeBillingLabel ">{{
    $t('pacto_settings_module_polish_language')
}}</label>
                      <input type="text" class="form-control streetInput"
                        :class="!loaderData && pactoPolishLanguageError ? ' form-control errClass' : ' form-control'"
                        v-model="pactoPolishLanguage" @keyup="polishLanguageValidation" />


                    </div>
                  </div>

                </div>
                <div class="col-md-12 firstDiv">
                  <h5 class="headingSecondStyle">{{ $t('pacto_settings_module_contact_information_heading') }}</h5>
                  <h6 class="headingStyle">{{ $t('pacto_settings_module_support_request_heading') }}</h6>
                  <div class="firstDiv">
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{ $t('pacto_settings_module_email_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="pactoEmail"
                          :class="!loaderData && pactoEmailError ? 'streetInput form-control errClass' : 'streetInput form-control'"
                          :placeholder="$t('users_module_search_popup_placeholder_email')" @keyup="emailValidation" />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{ $t('pacto_settings_module_phone_label')
}}</label>
                        <PhoneNumberInput :placeholder="$t('clo_user_add_user_popup_phone_placeholder')"
                          :phoneNumber="pactoPhone" :onPhoneNumberChange="onPactoPhoneNumberChange"
                          :validate="pactoValidate"
                          :class="!loaderData && pactoPhoneError ? 'streetInput form-control errClass' : 'streetInput form-control'" />
                      </div>
                    </div>
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_website_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="pactoWebsite"
                          :placeholder="$t('pacto_settings_module_website_placeholder')"
                          :class="!loaderData && pactoWebsiteError ? 'streetInput form-control errClass' : 'streetInput form-control'"
                          @keyup="websiteValidation" />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_whatsapp_label')
}}</label>
                        <PhoneNumberInput :placeholder="$t('clo_user_add_user_popup_phone_placeholder')"
                          :phoneNumber="pactoWhatsapp" :onPhoneNumberChange="onWhatsappPhoneNumberChange"
                          :validate="pactoWhatsappValidate"
                          :class="!loaderData && pactoWhatsappError ? 'streetInput form-control errClass' : 'streetInput form-control'" />

                      </div>
                    </div>
                    <h6 class="headingStyle">{{ $t('pacto_settings_module_complaints_heading') }}</h6>
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{ $t('pacto_settings_module_email_label')
}}</label>
                        <input type="text" class="form-control streetInput"
                          :class="!loaderData && pactoComplaintEmailError ? 'streetInput form-control errClass' : 'streetInput form-control'"
                          v-model="pactoComplaintEmail" :placeholder="$t('users_module_search_popup_placeholder_email')"
                          @keyup="complaintEmailValidation" />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{ $t('pacto_settings_module_phone_label')
}}</label>
                        <PhoneNumberInput :placeholder="$t('clo_user_add_user_popup_phone_placeholder')"
                          :phoneNumber="pactoComplaintPhone" :onPhoneNumberChange="onChangeComplaintPhone"
                          :validate="pactoComplaintPhoneValidate"
                          :class="!loaderData && pactoComplaintPhoneError ? 'streetInput form-control errClass' : 'streetInput form-control'" />
                      </div>
                    </div>
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_website_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="pactoComplaintWebsite"
                          :class="!loaderData && pactoComplaintWebsiteError ? 'streetInput form-control errClass' : 'streetInput form-control'"
                          :placeholder="$t('pacto_settings_module_website_placeholder')"
                          @keyup="complaintWebsiteValidation" />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_whatsapp_label')
}}</label>
                        <PhoneNumberInput :placeholder="$t('clo_user_add_user_popup_phone_placeholder')"
                          :phoneNumber="pactoComplaintWhatsapp" :onPhoneNumberChange="onChangeComplaintWhatsappNumber"
                          :validate="pactoComplaintWhatsappValidate"
                          :class="!loaderData && pactoComplaintWhatsappError ? 'streetInput form-control errClass' : 'streetInput form-control'" />
                      </div>
                    </div>
                  </div>
                  <div class="firstDiv">
                    <h6 class="headingStyle">{{ $t('pacto_settings_module_data_protection_heading') }}</h6>
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_data_protection_name_label')
}}</label>
                        <input type="text" class="form-control inputStyle" v-model="dataProtectionName"
                          :placeholder="$t('pacto_settings_module_data_protection_name_placeholder')"
                          :class="!loaderData && dataProtectionNameError ? 'inputStyle form-control errClass' : 'inputStyle form-control'"
                          @keyup="dataProtectionNameValidation" />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_data_protection_position_label')
}}</label>
                        <input type="text" class="form-control inputStyle" v-model="dataProtectionPosition"
                          :placeholder="$t('pacto_settings_module_data_protection_position_placeholder')"
                          :class="!loaderData && dataProtectionPositionError ? 'inputStyle form-control errClass' : 'inputStyle form-control'"
                          @keyup="dataProtectionPositionValidation" />

                      </div>

                    </div>
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{ $t('pacto_settings_module_email_label')
}}</label>
                        <input type="text" class="form-control inputStyle" v-model="dataProtectionEmail"
                          :placeholder="$t('users_module_search_popup_placeholder_email')"
                          :class="!loaderData && dataProtectionEmailError ? 'inputStyle form-control errClass' : 'inputStyle form-control'"
                          @keyup="dataProtectionEmailValidation" />

                      </div>
                    </div>
                  </div>
                  <div class="" style="padding-bottom: 2em;">
                    <h6 class="headingStyle">{{ $t('pacto_settings_module_gdpr_requests_heading') }}</h6>
                    <div class="col-md-11">
                      <div class="col-md-7" style="margin-left: -2em; padding-right: 2em;">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('pacto_settings_module_gdpr_requests_enter_link_label')
}}</label>
                        <input type="text" class="form-control inputStyle" v-model="gdprRequest"
                          :placeholder="$t('pacto_settings_module_gdpr_requests_enter_link_label')"
                          :class="!loaderData && gdprRequestError ? 'inputStyle form-control errClass' : 'inputStyle form-control'"
                          @keyup="gdprRequestValidation" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light-secondary ml-1 buttonSaveStyle" @click="cancelData()">
                  <em class="bx bx-check d-block d-sm-none"></em>
                  <span class="d-none d-sm-block">{{ $t('pacto_settings_module_gdpr_requests_cancel_button') }}</span>
                </button>
                <button type="button" class="btn btn-primary ml-1 buttonSaveStyle" @click="saveImageData()">
                  <em class="bx bx-check d-block d-sm-none"></em>
                  <span class="d-none d-sm-block">{{ $t('pacto_settings_module_gdpr_requests_save_button') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade text-left" id="edit-confirm-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content resetPasswordDialogue">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
    $t('pacto_settings_module_edit_confirm_heading')
}}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">

            <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
              {{ $t('pacto_settings_module_edit_confirm_message') }}</h3>
          </div>
          <div class="modal-footer modalFooter">


            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{
    $t('pacto_settings_module_edit_confirm_ok_button')
                }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import { v4 as generate_UUID } from 'uuid';
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";
import { getApp } from 'firebase/app'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { getStorage, ref, uploadString, getDownloadURL } from 'firebase/storage';

export default {
  name: "PactoSettingsPage",
  props: ['orgId'],
  components: {
    Alert,
    PhoneNumberInput
  },
  data() {
    return {
      pactoEmail: "",
      pactoPhone: 0,
      pactoWebsite: "",
      pactoWhatsapp: 0,
      pactoComplaintEmail: "",
      pactoComplaintPhone: 0,
      pactoComplaintWebsite: "",
      pactoComplaintWhatsapp: 0,
      dataProtectionName: "",
      dataProtectionPosition: "",
      dataProtectionEmail: "",
      gdprRequest: "",
      orgId: this.$route.params.org,
      organisationSettings: [],
      pactoDefaultLanguage: '',
      pactoPolishLanguage: '',
      coordinates: '',
      file: '',
      icons: "",
      data: {},
      closeImage: require('@/assets/close.png').default,
      submitted: false,
      requiredError: false,
      emailError: false,
      nameError: false,
      apiError: false,
      apiErrorText: '',
      error: false,
      pactoEmailError: false,
      pactoPhoneError: false,
      pactoWebsiteError: false,
      pactoWhatsappError: false,
      pactoComplaintEmailError: false,
      pactoComplaintPhoneError: false,
      pactoComplaintWebsiteError: false,
      pactoComplaintWhatsappError: false,
      dataProtectionNameError: false,
      dataProtectionPositionError: false,
      dataProtectionEmailError: false,
      gdprRequestError: false,
      pactoDefaultLanguageError: false,
      pactoPolishLanguageError: false,
      tokenData: '',
      uploadImage: false,
      saveImageChange: false,
      loadingData: false,
      iconError: false,
      pactoPhoneValidError: false,
      phoneWhatsappValidError: false,
      phoneComplaintValidError: false,
      pactoComplaintWhatsappValidError: false,
      pactoComplaintPhoneErrorValid: false,
      loaderData: true


    }
  },
  methods: {
    onPactoPhoneNumberChange(value) {
      this.pactoPhone = value;
    },
    onWhatsappPhoneNumberChange(value) {
      this.pactoWhatsapp = value;
    },
    onChangeComplaintPhone(value) {
      this.pactoComplaintPhone = value;
    },
    onChangeComplaintWhatsappNumber(value) {
      this.pactoComplaintWhatsapp = value;
    },
    onFileChange(e) {
      console.log("upload", e);
      let self = this;
      self.loadingData = true;
      self.uploadImage = true;
      let file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.icons = reader.result;
        console.log('Base64Format>>>', this.icons);
      }
      self.loadingData = false;

    },
    deleteLogo() {
      let self = this;
      self.url = "";
      self.icons = ''
    },
    cancelData() {
      let self = this;
      self.pactoEmail = '';
      self.pactoPhone = 0;
      self.pactoWebsite = '';
      self.pactoWhatsapp = 0;
      self.pactoComplaintEmail = '';
      self.pactoComplaintPhone = 0;
      self.pactoComplaintWebsite = '';
      self.pactoComplaintWhatsapp = 0;
      self.dataProtectionName = '';
      self.dataProtectionPosition = '';
      self.dataProtectionEmail = '';
      self.gdprRequest = '';
      self.icons = '';
      self.pactoDefaultLanguage = '';
      self.pactoPolishLanguage = '';
      self.requiredError = false;
      self.emailError = false;
      self.nameError = false;
      self.pactoEmailError = false;
      self.pactoPhoneError = false;
      self.pactoWebsiteError = false;
      self.pactoWhatsappError = false;
      self.pactoComplaintEmailError = false;
      self.pactoComplaintPhoneError = false;
      self.pactoComplaintWebsiteError = false;
      self.pactoComplaintWhatsappError = false;
      self.dataProtectionNameError = false;
      self.dataProtectionPositionError = false;
      self.dataProtectionEmailError = false;
      self.gdprRequestError = false;
      self.pactoDefaultLanguageError = false;
      self.pactoPolishLanguageError = false;
      self.pactoPhoneValidError = false;
      self.phoneWhatsappValidError = false;
      self.phoneComplaintValidError = false;
      self.pactoComplaintWhatsappValidError = false;
      self.pactoComplaintPhoneErrorValid = false;
      self.getPactoSettingsData()

    },
    defaultLanguageValidation() {
      let self = this;
      console.log('aaaaaaaa', self.pactoDefaultLanguage)
      if (self.pactoDefaultLanguage != "") {
        self.requiredError = false;
        self.pactoDefaultLanguageError = false;
        if (/^[A-Za-z]+$/.test(self.pactoDefaultLanguage)) {
          self.pactoDefaultLanguageError = false;
          self.nameError = false
        } else {
          self.pactoDefaultLanguageError = true;
          self.nameError = true;
        }
      } else {
        self.requiredError = true;
        self.pactoDefaultLanguageError = true;
      }
    },
    polishLanguageValidation() {
      let self = this;
      if (self.pactoPolishLanguage == "") {
        self.requiredError = true;
        self.pactoPolishLanguageError = true;

      } else {
        self.requiredError = false;
        self.pactoPolishLanguageError = false;

      }
    },
    emailValidation() {
      let self = this; 

      if (self.pactoEmail != "") {
        self.requiredError = false;
        self.pactoEmailError = false;
        if (this.$filters.validateEmail(self.pactoEmail)) {
          self.pactoEmailError = false;
          self.emailError = false
        } else {
          self.pactoEmailError = true;
          self.emailError = true;
        }
      } else {
        self.requiredError = true;
        self.pactoEmailError = true;
      }

    },
    websiteValidation() {
      let self = this;
      if (self.pactoWebsite != "") {
        self.requiredError = false;
        self.pactoWebsiteError = false;
      } else {
        self.requiredError = true;
        self.pactoWebsiteError = true;
      }
    },
    complaintEmailValidation() {
      let self = this;
      if (self.pactoComplaintEmail != "") {
        self.requiredError = false;
        self.pactoComplaintEmailError = false;
        if (this.$filters.validateEmail(self.pactoComplaintEmail)) {
          self.pactoComplaintEmailError = false;
          self.emailError = false
        } else {
          self.pactoComplaintEmailError = true;
          self.emailError = true;
        }
      } else {
        self.requiredError = true;
        self.pactoComplaintEmailError = true;
      }
    },
    complaintWebsiteValidation() {
      let self = this;
      if (self.pactoComplaintWebsite != "") {
        self.requiredError = false;
        self.pactoComplaintWebsiteError = false;
      } else {
        self.requiredError = true;
        self.pactoComplaintWebsiteError = true;
      }

    },
    dataProtectionNameValidation() {
      let self = this;
      if (self.dataProtectionName != "") {
        self.requiredError = false;
        self.dataProtectionNameError = false;
        if (/^[A-Za-z]+$/.test(self.dataProtectionName)) {
          self.dataProtectionNameError = false;
          self.nameError = false
        } else {
          self.dataProtectionNameError = true;
          self.nameError = true;
        }
      } else {
        self.requiredError = true;
        self.dataProtectionNameError = true;
      }

    },
    dataProtectionPositionValidation() {
      let self = this;
      if (self.dataProtectionPosition != "") {
        self.requiredError = false;
        self.dataProtectionPositionError = false;
        if (/^[A-Za-z]+$/.test(self.dataProtectionPosition)) {
          self.dataProtectionPositionError = false;
          self.nameError = false
        } else {
          self.dataProtectionPositionError = true;
          self.nameError = true;
        }
      } else {
        self.requiredError = true;
        self.dataProtectionPositionError = true;
      }
    },
    dataProtectionEmailValidation() {
      let self = this;
      if (self.dataProtectionEmail != "") {
        self.requiredError = false;
        self.dataProtectionEmailError = false;
        if (this.$filters.validateEmail(self.dataProtectionEmail)) {
          self.dataProtectionEmailError = false;
          self.emailError = false
        } else {
          self.dataProtectionEmailError = true;
          self.emailError = true;
        }
      } else {
        self.requiredError = true;
        self.dataProtectionEmailError = true;
      }
    },
    gdprRequestValidation() {
      let self = this;
      if (self.gdprRequest != "") {
        self.requiredError = false;
        self.gdprRequestError = false;
      } else {
        self.requiredError = true;
        self.gdprRequestError = true;
      }

    },
    getPactoSettingsData() {
      console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
      let self = this;
      this.$apiCall.get(`v1/clo-organization/${self.orgId}/settings`).then((response) => {

        console.log("response--pacto-settings", response.data);
        self.organisationSettings = response.data.organizationSetting;
        self.pactoEmail = self.organisationSettings.supportRequest.email;
        self.pactoPhone = self.organisationSettings.supportRequest.phoneNumber
        self.pactoWebsite = self.organisationSettings.supportRequest.website;
        self.pactoWhatsapp = self.organisationSettings.supportRequest.whatsApp
        self.pactoComplaintEmail = self.organisationSettings.complaintFeedback.email;
        self.pactoComplaintPhone = self.organisationSettings.complaintFeedback.phoneNumber
        self.pactoComplaintWebsite = self.organisationSettings.complaintFeedback.website;
        self.pactoComplaintWhatsapp = self.organisationSettings.complaintFeedback.whatsApp
        self.dataProtectionName = self.organisationSettings.protectionOfficer.name;
        self.dataProtectionPosition = self.organisationSettings.protectionOfficer.position;
        self.dataProtectionEmail = self.organisationSettings.protectionOfficer.email;
        self.gdprRequest = self.organisationSettings.protectionOfficer.gdprLink;
        self.icons = self.organisationSettings.logo;
        self.pactoDefaultLanguage = self.organisationSettings.shortName.en.name;
        self.pactoPolishLanguage = self.organisationSettings.shortName.pl.name;
        self.loaderData = false;
        console.log("org--settings-------", self.organisationSettings)
      }).catch((error) => {
      });
    },
    pactoValidate(telnumber) {
      let self = this
      console.log("pacto-validate")
      if (telnumber.valid) {
        console.log("validddddd", telnumber)
        self.pactoPhoneError = false;
        self.pactoPhoneValidError = false
      } else {
        self.pactoPhoneError = true;
        self.pactoPhoneValidError = true;
      }
    },
    pactoWhatsappValidate(telnumber) {
      console.log("pactoWhatsappValidate ", telnumber)
      let self = this
      if (telnumber.valid) {
        self.pactoWhatsappError = false;
        self.phoneWhatsappValidError = false
      } else {
        self.pactoWhatsappError = true;
        self.phoneWhatsappValidError = true;
      }
    },

    pactoComplaintPhoneValidate(telnumber) {
      console.log("pactoComplaintPhoneValidate ", telnumber)
      let self = this
      if (telnumber.valid) {
        self.pactoComplaintPhoneErrorValid = false
        self.pactoComplaintPhoneError = false;
      } else {
        self.pactoComplaintPhoneErrorValid = true
        self.pactoComplaintPhoneError = true;
      }
    },

    pactoComplaintWhatsappValidate(telnumber) {
      let self = this
      if (telnumber.valid) {
        self.pactoComplaintWhatsappError = false;
        self.pactoComplaintWhatsappValidError = false;

      } else {
        self.pactoComplaintWhatsappError = true;
        self.pactoComplaintWhatsappValidError = true
      }
    },


    storeImage() {
      let self = this;

      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      if (self.icons) {
        self.iconError = false;
        let imageNameUUID = generate_UUID();
        const firebaseApp = getApp();
        const firebaseAuth = getAuth(firebaseApp);
        signInWithCustomToken(firebaseAuth, self.tokenData)
          .then((userCredential) => {
            console.log("token userCredential", self.tokenData);
            console.log("this.$storage => ", this.$storage)
            const storage = getStorage(firebaseApp)
            const imageReference = ref(storage, `/clologo/${imageNameUUID}`);
            console.log("url", self.icons);
            uploadString(imageReference, self.icons, 'data_url')
              .then(() => getDownloadURL(imageReference))
              .then(link => {
                console.log("linkkkkkkkkkkk", link);

                self.file = null;
                self.icons = link
                self.saveData()
                $.unblockUI();
              })

          })
      } else {
        self.iconError = true;
      }


    },
    saveImageData() {

      let self = this;

      if (self.icons != "") {
        self.iconError = false;
      } else {
        self.iconError = true;
      }

      if (!self.pactoEmailError && !self.pactoPhoneError && !self.pactoWebsiteError && !self.pactoWhatsappError && !self.pactoComplaintEmailError && !self.pactoComplaintPhoneError
        && !self.pactoComplaintWebsiteError && !self.pactoComplaintWhatsappError && !self.dataProtectionNameError && !self.dataProtectionPositionError && !self.dataProtectionEmailError
        && !self.gdprRequestError && !self.iconError && !self.pactoDefaultLanguageError && !self.pactoPolishLanguageError) {
        if (self.uploadImage && !self.saveImageChange) {
          self.storeImage()
        } else if (!self.uploadImage && !self.saveImageChange) {
          self.saveData()
        }
        else if (!self.uploadImage && self.saveImageChange) {
          self.saveData()
        }
        else if (self.uploadImage && self.saveImageChange) {
          self.storeImage()
        }
      }
    },

    saveData() {

      console.log("save-data");
      let self = this;
      self.saveImageChange = true;
      self.submitted = true;

      self.data = {
        supportRequest: {
          email: self.pactoEmail,
          phoneNumber: self.pactoPhone,
          website: self.pactoWebsite,
          whatsApp: self.pactoWhatsapp
        },
        complaintFeedback: {
          email: self.pactoComplaintEmail,
          phoneNumber: self.pactoComplaintPhone,
          website: self.pactoComplaintWebsite,
          whatsApp: self.pactoComplaintWhatsapp
        },
        protectionOfficer: {
          name: self.dataProtectionName,
          position: self.dataProtectionPosition,
          email: self.dataProtectionEmail,
          gdprLink: self.gdprRequest
        },
        logo: self.icons,
        shortName: {
          en: {
            name: self.pactoDefaultLanguage
          },
          pl: {
            name: self.pactoPolishLanguage
          }
        }
      }
      console.log("data.......", self.data);
      this.$apiCall.patch(`v1/clo-organization/${self.orgId}/settings`, self.data).then((response) => {
        $("#edit-confirm-modal").modal();

      }).catch((error) => {
        self.apiError = true;
        self.apiErrorText = `<strong>Ops!</strong> ${error.response.data.message}`;
      })

    },
    getToken() {
      let self = this;
      this.$apiCall.get(`v1/me/customToken`).then((response) => {
        console.log("respppppppppppppp", response.data);
        self.tokenData = response.data;
      })
    }

  },
  mounted() {
    console.log("mountedddd");

    this.getToken()
    this.getPactoSettingsData()
  }
}
</script>

<style>
.headingStyle {
  font-weight: 500;
  color: #475F7B;
  margin-top: 2em;
  margin-left: 2em;

}

.headingStyleOrg {
  font-weight: 500;
  /* font-size: 16px; */
  color: #475F7B;
  margin-top: 2em;
}

.headingGdprStyle {
  font-weight: 500;
  /* font-size: 16px; */
  color: #475F7B;
  margin-top: 2em;
  margin-left: 4em;

}

.headingSecondStyle {
  font-weight: 500;
  /* font-size: 16px; */
  color: #475F7B;
  margin-top: 1em;
  margin-left: 1.5em;
}

.uploadDiv {
  border: 1px solid black;
  border-style: dashed;
  margin-bottom: 3em
}

.firstDiv {
  border-bottom: 1px solid rgba(189, 190, 190, 0.5);
  ;
}

.streetRow {
  margin-top: 1em
}

.postalCodeBillingLabel {
  color: #4A4949;
  font-size: 16px;
  font-weight: 400;
  margin-left: 2em;
}

.streetInput {
  height: 3em;
  width: 94%;
  margin-left: 2em;
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
}

.languageInput {
  width: 53em;
  margin-left: 10em;
  height: 3em;
}

.englishInput {
  width: 53em;
  margin-left: 1em;
  height: 3em;
}

.flagAlign {
  transform: translate(2em, -39px);
  border: 0px !important;
}

.inputStyle {
  width: 94%;
  margin-left: 2em;
  height: 3em;

}

.buttonDeleteLogoStyle {
  background-color: #D9D9D9 !important;
}

.deleteLogoFont {
  color: black;
}

.buttonChangeStyle {
  background-color: #546E7A !important;
  ;
}

.uploadDivStyle {
  padding-top: 2em;
  padding-bottom: 3em;
}

.uploadButtonStyle {
  margin-top: 2em;
}

.dimensionStyle {
  margin-left: -2em;
  margin-top: 3em;
}

.buttonStyleMargin{
  margin-top: 2em;
}

.englishLabel {
  color: rgba(74, 73, 73, 0.7);
  margin-left: 1em;
}

.polishLabel {
  color: rgba(74, 73, 73, 0.7);
  margin-left: 9.5em;
}

.resetPasswordDialogue {
  height: 19em;
  border-radius: 1rem !important;
  margin-top: 35%;
}

.resetPasswordHeading {
  color: #4A0A1E;
  font-size: 18px !important;
  font-weight: 450 !important;
}

.resetPasswordSuccessHeading {
  color: #767676;
  font-size: 20px !important;
  font-weight: 400 !important;
  text-align: center;
  margin-top: 4%;
}

.errClass {
  border: 1px solid red;
}

.dotedDivStyle {
  display: flex;
  justify-content: center;
  margin-left: 1em;
}

@media (max-width:1366px) {
  .resetPasswordDialogue {
    height: 19em;
    border-radius: 1rem !important;
    transform: translate(2em, -71px);
  }

  .uploadDiv {
    border: 1px solid black;
    border-style: dashed;
    margin-bottom: 3em;
    width: 47em;
  }

  .uploadDivStyle {
    padding-top: 4em;
    padding-bottom: 2em;
  }

  .formatStyle {
    transform: translate(2px, -21px);
    margin-top: 2em;
  }

  .englishInput {
    width: 28.5em;
    margin-left: 1em;
    height: 3em;
  }

  .languageInput {
    width: 28.5em;
    margin-left: 7em;
    height: 3em;
  }

  .polishLabel {
    color: rgba(74, 73, 73, 0.7);
    margin-left: 6.7em;
  }


}
</style>